export default "__VITE_ASSET__CNvVJpPi__"